import { Component } from '@angular/core';

@Component({
  selector: 'app-org-root',
  templateUrl: './org-root.component.html',
  styleUrl: './org-root.component.scss'
})
export class OrgRootComponent {

}
